import clsx from "clsx";
import { FC, ReactNode } from "react";
import { useRecoilValue } from "recoil";

import { useClickOutside, usePageContext } from "@ryde/redux";
import { areFiltersPausedSF } from "@ryde/shared";

import { FilterMultiselectWrapper } from "./filter-multiselect.styled";

interface IFilterDropdownProps {
  children?: ReactNode;
  readonly isOpen: boolean;
  readonly target: ReactNode;
  readonly onClose: () => void;
  dropdownHasSelectedItems?: boolean;
  isFilterItem?: boolean;
}

export const FilterDropdownWrapper: FC<IFilterDropdownProps> = ({
  children,
  isOpen,
  target,
  onClose,
  dropdownHasSelectedItems,
  isFilterItem,
}) => {
  const { entity } = usePageContext();
  const { clickRef } = useClickOutside<HTMLDivElement>({
    handleClose: onClose,
  });

  const isBorderSuspended = useRecoilValue(areFiltersPausedSF(entity));

  const isBorderHighlighted = Boolean(
    isFilterItem && dropdownHasSelectedItems && !isBorderSuspended,
  );

  return (
    <FilterMultiselectWrapper
      ref={clickRef}
      className={clsx({
        "filter-border__highlighted": isBorderHighlighted,
        "filter-border__suspended": isBorderSuspended,
      })}
    >
      {target}
      {isOpen ? <div className="menu-multiselect">{children}</div> : null}
    </FilterMultiselectWrapper>
  );
};
